import { JsonValue } from 'type-fest';

export function setItemInLS(key: string, value: JsonValue): void {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getItemFromLS<T>(key: string, defaultValue: T): T {
  const value = localStorage.getItem(key);
  if (!value) {
    return defaultValue;
  }

  return JSON.parse(value);
}

export function getAndDeleteItemFromLS<T>(key: string, defaultValue: T): T {
  const item = getItemFromLS(key, defaultValue);
  localStorage.removeItem(key);
  return item;
}
